export const CURRENCY_CHAR = '₽';
